export default {
  BusinessReportSaleCensus: {
    orderTime: 'Statistics time',
    dateType: 'Statistics time type',
    channel: 'Channel',
    totalSales: 'Order Details',
    orderCount: 'Sales Order QTY',
    orderCount2: 'Sales Order No.',
    itemCount: 'Sold Item QTY',
    orderAmount: 'Positive order amount',
    reverseOrderCount: 'Return Order QTY',
    reverseOrderCount2: 'Return Order No.',
    reverseItemCount: 'Return Item QTY',
    reverseOrderAmount: 'Reverse refund amount',
    reverseItem: 'Net sales item count',
    netSalesAmount: 'Net sales amount',
    itemCost: 'Total cost of goods',
    itemProfit: 'Gross profit',
    channelTypeMeaning: 'Sales Channel',
    totalSave: 'Order Details',
    goodsQuantity: 'Positive sales amount',
  }
};
